import React from 'react'
import './style.css';
import { Modal, Table } from '@vwfs-bronson/bronson-react'
import { IBillingError } from '../../../models/customer-data.interface'
import { formatter } from '../../../utils/time-utils';

interface ErrorsModalInterface {
  errors: IBillingError[],
  showModal: boolean,
  handleOnClose: () => void
}

export default function ErrorsModal({ errors, showModal, handleOnClose }: ErrorsModalInterface) {
  const renderInvoiceTable = () => {
    return (
      <Table colored={true} testId="test-invoices-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Invoice number</Table.Th>
            <Table.Th>Details</Table.Th>
            <Table.Th>Time</Table.Th>
          </Table.Tr>
          {
            errors.map(error => {

              return (
                <Table.Tr key={error.code + '_' + error.timestamp} className="table-row">
                  <Table.Td>{error.invoiceNumber || ""}</Table.Td>
                  <Table.Td style={{ maxWidth: '350px' }}>{error.details || ""}</Table.Td>
                  <Table.Td>{error.timestamp ? formatter.format(new Date(error.timestamp)) : ""}</Table.Td>
                </Table.Tr>)
            })
          }
        </Table.Thead>
      </Table >
    )
  }

  return <Modal
    shown={showModal}
    onClose={handleOnClose}
    onConfirm={handleOnClose}
    buttonConfirmLabel="Ok"
    buttonConfirmText="Ok"
    title={`Errors`}
    large={true}
    status='info'
    testId='test-invoices-table-modal'>
    {renderInvoiceTable()}
  </Modal>
}
